export default __webpack_public_path__ + "static/media/img-guide-gt-popup-1.be3980ce.png";